import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';

import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import CollapsibleSnackBar from 'client/pages/MapPage/components/SnackBars/CollapsibleSnackBar/CollapsibleSnackBar';

import { mdiClose, mdiDomain } from '@mdi/js';

import { mapMenuTabKeys } from 'client/utils/constants/appStates';
import styles from '../button.module.scss';
import Icon from '@mdi/react';
import Button from 'client/components/aria/Button/Button';
import Link from 'client/components/aria/Link/Link';
import { setMenuOpen, setMenuSelectedTab } from 'client/store/mapSlice/mapSlice';

const CustomMappingSnackBar = () => {
    const intl = useIntl();
    const assetsInAOIOwners = useSelector(state => state?.assetOwners?.data?.assetsInAOIOwners);
    const hasCustomBackdropMap = (assetsInAOIOwners || []).some(owner => owner.hasCustomBackdropMap);
    const [dismissed, setDismissed] = useState(false);
    const selectedTab = useSelector(state => state?.map?.menuSelectedTab);
    const dispatch = useDispatch();

    useEffect(() => {
        setDismissed(selectedTab !== mapMenuTabKeys.LAYERS);
    }, [selectedTab]);

    const handleLinkClick = () => {
        dispatch(setMenuOpen(true));
        dispatch(setMenuSelectedTab(mapMenuTabKeys.ISOLATED_VIEWS));
    };

    const closeButton = <Button
        data-testid="customMapping.closeAlert"
        variant="transparent"
        className={styles.button}
        aria-label={ intl.formatMessage({ id: 'general.closeNotification' }) }
        onPress={() => { setDismissed(true); }}
    >
        <Icon path={mdiClose} size={1}/>
    </Button>;

    return !dismissed && (hasCustomBackdropMap)
        ? <SnackBar variant="warning" endOfLine={closeButton}>
            <CollapsibleSnackBar
                icon={mdiDomain}
                label={ intl.formatMessage({ id: 'customMapping.notification.label' })}
                data-testid="customMapping.alert"
            >
                <FormattedMessage id='customMapping.alert' />
                &nbsp;
                <Link data-testid="customMapping.alert.viewLink" onClick={handleLinkClick}>
                    {intl.formatMessage({ id: 'customMapping.link' })}
                </Link>
            </CollapsibleSnackBar>
        </SnackBar>
        : null;
};

export default CustomMappingSnackBar;
